/* global axios */
import ApiClient from './ApiClient';

/**
 * Jornada de trabalho por agente (Portela, 19/10/2026).
 * Fase 3 do ESTUDO-relatorio-por-agente.md.
 *
 * O Chatwoot só tem horário de funcionamento da CAIXA DE ENTRADA. Isto guarda o
 * do agente — "segunda a sexta das 8 às 18, sábado até meio-dia" — que é o que
 * dá escala ao tempo online: "7h30 de 9h" em vez de "7h30".
 */
class AgentScheduleAPI extends ApiClient {
  constructor() {
    super('agent_schedule', { accountScoped: true, apiVersion: 'v2' });
  }

  get(userId) {
    return axios.get(this.url, { params: { user_id: userId } });
  }

  // Manda a semana INTEIRA: o servidor apaga e regrava. Casar dia a dia deixaria
  // sobrar um dia antigo que ninguém vê na tela e que continua somando.
  save(userId, dias) {
    return axios.put(this.url, { user_id: userId, dias });
  }
}

export default new AgentScheduleAPI();
